<template>
  <div id="news">
    <div class="">
      <ol class="breadcrumb">
        <li>
          <a href="#/dashboard">Dashboard</a>
        </li>
        <li class="active">
          <a>Finder</a>
        </li>
      </ol>
    </div>
    <div class="content login middle">
      <div class="cell">
        <div class="container pb100">
          <div class="row mt50">
            <a href="#/dashboard/" class="font16 backto hidden-xs">
              <i class="iconfont3 icon-back"></i> BACK TO DASHBOARD
            </a>

            <div class="row">
              <div class="col-xs-12 text-center">
                <div class="col-xs-4">
                  <el-input
                    v-model="artwork_id"
                    size="big"
                    placeholder="Artwork Ref ID#"
                    class="mt20"
                  ></el-input>
                  <button type="button" class="ebutton" @click="goToArtwork()">Go to artwork</button>
                </div>
                <div class="col-xs-4">
                  <el-input
                    v-model="product_id"
                    size="big"
                    placeholder="Product Ref ID#"
                    class="mt20"
                  ></el-input>
                  <button type="button" class="ebutton" @click="goToProduct()">Go to product</button>
                </div>
                <div class="col-xs-4">
                  <el-input
                    v-model="project_id"
                    size="big"
                    placeholder="Project ID#"
                    class="mt20"
                  ></el-input>
                  <button type="button" class="ebutton" @click="goToProject()">Go to project</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";

export default {
  name: "finder",
  data() {
    return {
      artwork_id: "",
      product_id: "",
      project_id: ""
    };
  },
  methods: {
    async goToArtwork() {
      if (this.artwork_id != "") {
        var response = await axios("/artwork/findbyrefid/" + this.artwork_id);
        if (response.data.error) {
          alert(response.data.error)
        } else {
          this.$router.push("/artwork/" + response.data._id);
        }
      }
    },
    async goToProduct() {
      if (this.product_id != "") {
        var response = await axios("/product/findbyrefid/" + this.product_id);
        if (response.data.error) {
          alert(response.data.error)
        } else {
          this.$router.push("/artwork/p" + response.data._id);
        }
      }
    },
    async goToProject() {
      if (this.project_id != "") {
        var response = await axios("/project/findbypid/" + this.project_id);
        if (response.data.error) {
          alert(response.data.error)
        } else {
          this.$router.push("/project/" + response.data._id);
        }
      }
    }
  }
};
</script>

<style>
</style>